var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrid6(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 640,
    height: 360,
    viewBox: "0 0 640 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1473_19475)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.9285 195.527C24.9285 196.557 24.703 197.523 24.303 198.37H15.0183C14.6183 197.523 14.3928 196.557 14.3928 195.527C14.3928 192.202 16.7502 189.508 19.6607 189.508C22.5711 189.508 24.9285 192.202 24.9285 195.527Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M640 0H0V360H640V0Z",
    fill: "#90A8ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.94 108.711H235.375V213.406H302.94V108.711Z",
    fill: "#F1F333",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.625 108.711H302.94V213.406H310.625V108.711Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.055 108.711H310.625V213.406H316.055V108.711Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321.485 108.711H316.055V213.406H321.485V108.711Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.88 108.711H321.485V213.406H325.88V108.711Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.485 129.009H249.73C250.205 123.004 243.03 121.229 240.96 126.329C238.89 131.429 241.565 138.989 250.335 134.844",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.175 129.688H256.865",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M260.415 123.483V135.418H264.2C264.395 135.268 265.745 134.373 265.745 132.738C265.745 129.488 263.67 129.163 263.54 129.068C266.205 127.693 265.54 120.253 258.49 124.178",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.54 129.062H260.415",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.17 134.799C273.645 134.799 274.84 132.37 274.84 129.374C274.84 126.378 273.645 123.949 272.17 123.949C270.695 123.949 269.5 126.378 269.5 129.374C269.5 132.37 270.695 134.799 272.17 134.799Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.095 129.829C284.53 132.284 282.65 134.829 280.625 134.829C279.14 134.829 278.625 132.759 278.625 129.829C278.625 126.899 278.505 124.309 280.015 124.309C281.53 124.309 283.415 125.954 284.095 129.829Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.315 122.734V136.019",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.19 123.734L287.315 129.794",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.18 129.035L294.51 133.56",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M575.125 99.5016C570.125 107.252 547.625 103.127 538 102.377C528.625 99.6262 539 82.5016 552.875 75.5016C566.75 68.5016 582.125 76.3766 582.125 80.8766C582.125 85.3766 580.125 91.7516 575.125 99.5016Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625.22 64.7431L622.09 59.2631C621.52 58.2681 620.34 57.7981 619.245 58.1281L595.715 65.2831L572.43 72.3631L528.985 85.5781C528.985 85.5781 527.735 94.8731 526.21 102.348L621.935 73.0281C625.435 71.9581 627.035 67.9181 625.22 64.7431ZM623.28 275.343L363.135 152.298L510.475 107.168C510.735 103.313 511.735 98.1581 513.215 92.4031C513.25 91.6981 513.29 91.0081 513.33 90.3381L341.715 142.533C337.21 135.668 329.575 131.273 319.025 130.718C302.495 129.848 287.99 142.473 286.56 159.988C286.49 160.803 286.455 161.618 286.445 162.428H299.73C299.465 138.723 331.64 140.068 335.515 157.343C338.175 169.088 333.155 178.448 324.265 181.173L326.045 192.458C336.81 189.248 344.73 180.618 346.305 164.868C346.465 163.288 346.54 161.738 346.54 160.228L618.655 288.058C619.725 288.558 621 288.228 621.69 287.268L625.125 282.483C626.87 280.048 625.985 276.628 623.28 275.343ZM346.15 152.883C346.045 152.883 345.94 152.878 345.84 152.858C344.61 152.713 343.66 151.663 343.66 150.393C343.66 149.593 344.035 148.883 344.625 148.428C345.045 148.098 345.575 147.903 346.15 147.903C347.525 147.903 348.64 149.018 348.64 150.393C348.64 151.768 347.525 152.883 346.15 152.883Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.58 213.62C565.58 213.62 561.875 210.895 554.035 209.075C546.195 207.255 527.805 205.13 514.945 206.19C505.63 207.295 505.365 205.92 501.41 204.125C497.455 202.33 487.955 197.68 485.425 201.01C482.895 204.34 487.955 212.525 493.545 216.11C486.65 224.12 481.275 233.41 483.35 240.195C485.425 246.98 498.95 238.07 500.115 234.51C495.545 246.98 498.38 261.325 511.2 248.23C511.2 248.23 510.18 264.78 522.605 255.945C524.12 254.27 524.61 254.535 524.61 254.535C524.61 254.535 522.105 267.8 530.845 265.7C534.82 264.405 537.195 262 540.505 254.61C543.815 247.22 547.43 239.465 547.43 239.465L569.7 250C569.7 250 578.65 248.595 580.8 241.85C579.975 240.33 565.58 213.62 565.58 213.62Z",
    fill: "#23A094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.51 213.497C550.43 204.017 511.4 206.002 506.675 206.782C501.075 207.702 488 218.752 483.51 233.117C479.33 246.487 493.505 243.937 499.54 235.387C503.305 230.052 508.595 214.592 517.57 212.242",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.855 234.918C493.065 252.078 503.46 259.673 511.795 247.393C516.63 240.268 520.625 216.848 536.445 214.328",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M513.155 244.958C507.725 257.168 517.47 264.102 524.965 253.107C528.845 247.412 532.585 226.878 546.515 225.438",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M525.75 251.773C520.48 272.348 534.9 267.023 538.975 258.003C544.14 246.563 548.54 236.578 548.54 236.578",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.675 206.78C494.01 200.155 485.03 196.94 484.79 203.11C484.55 209.28 493.87 216.375 493.87 216.375",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588.285 162.953L627.76 227.828L581 242.228L565.51 213.493L588.285 162.953Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.005 183.855L645.95 145.695L645.99 197.575L621.21 217.065L601.005 183.855Z",
    fill: "#F4F4F0",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M552.205 40.4848L564 -5L616 -13L595.915 48.9648L552.205 40.4848Z",
    fill: "#F4F4F0",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.75 67.2802L531.515 36.5352L604.215 50.1652L595.715 65.2852L594.095 68.1702L579.555 73.7552C579.555 73.7552 576.76 73.1752 572.43 72.3652",
    fill: "#23A094"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M532.75 67.2802L531.515 36.5352L604.215 50.1652L595.715 65.2852L594.095 68.1702L579.555 73.7552C579.555 73.7552 576.76 73.1752 572.43 72.3652",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M555.395 103.889C555.395 113.374 553.175 121.059 548.925 121.059C544.675 121.059 542.09 113.369 542.09 103.889C542.09 94.4087 547.19 86.7188 548.925 86.7188C550.48 86.7188 555.395 94.4037 555.395 103.889Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541.175 105.032C539.565 114.377 536.795 121.937 531.47 120.762C526.14 119.587 525.36 112.072 526.975 102.727C528.585 93.3822 534.67 87.0372 537.23 87.4572C539.5 87.8622 542.785 95.6872 541.175 105.032Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M569.155 101.556C569.155 111.411 568.225 118.931 562.69 118.931C557.945 118.931 555.72 111.356 555.72 101.501C555.72 91.6458 558.97 85.5508 562.69 85.5508C566.555 85.5508 569.155 91.7008 569.155 101.556Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M583.105 98.2087C583.105 108.064 581.605 115.554 576.065 115.554C571.32 115.554 569.975 108.014 569.975 98.1588C569.975 88.3038 572.285 82.7188 576.17 82.7188C579.535 82.7188 583.105 88.3537 583.105 98.2087Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.91 236.666H160.825C158.645 236.666 156.875 234.896 156.875 232.716C156.875 230.536 158.645 228.766 160.825 228.766H408.91C411.09 228.766 412.86 230.536 412.86 232.716C412.86 234.896 411.09 236.666 408.91 236.666Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.085 236.664H162.785V365.998H405.085V236.664Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.785 292.617H405.085",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.27 34.9554C200.355 33.0104 200.525 28.3004 200.525 28.3004C200.729 22.9764 190.593 18.2151 185.5 16.5C190.423 14.4999 196.816 5.59961 183 -14.0004C165.73 -38.5004 118.5 -23.0004 107 -17.0004C95.5 -11.0004 90 9.49961 99.78 28.3054C112.85 51.7654 132.255 46.4704 139.905 40.6504C141.215 55.0354 153.46 62.3404 168.48 52.1554C163.645 69.7454 176.195 82.4004 194.815 68.8204C197.075 86.9304 214.37 69.7954 221.565 84.4954C225.845 78.9704 226.505 68.5004 225.575 66.3504C224.64 64.1804 216.715 60.5904 208.705 65.6304C213.905 56.8054 214.625 50.7204 212.32 47.6754C208.815 43.0454 196.425 46.7904 191.5 49.6654C198.69 41.1454 200.205 36.4804 200.27 34.9554Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.525 28.3004C200.525 28.3004 200.355 33.0104 200.27 34.9554C200.205 36.4804 198.69 41.1454 191.5 49.6654C196.425 46.7904 208.815 43.0454 212.32 47.6754C214.625 50.7204 213.905 56.8054 208.705 65.6304C216.715 60.5904 224.64 64.1804 225.575 66.3504C226.505 68.5004 225.845 78.9704 221.565 84.4954C214.37 69.7954 197.075 86.9304 194.815 68.8204C176.195 82.4004 163.645 69.7454 168.48 52.1554C153.46 62.3404 141.215 55.0354 139.905 40.6504C132.255 46.4704 112.85 51.7654 99.78 28.3054C90 9.49961 95.5 -11.0004 107 -17.0004C118.5 -23.0004 165.73 -38.5004 183 -14.0004C196.816 5.59961 190.423 14.4999 185.5 16.5C190.593 18.2151 200.729 22.9764 200.525 28.3004ZM200.525 28.3004V28.3054",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.96 101.967C397.035 107.257 400.575 92.5667 397.075 87.4817C409.95 89.1667 412.625 87.5017 412.665 84.0117C412.71 79.5417 399.43 75.6867 399.43 75.6867C413.15 77.8317 427.525 77.9417 423.325 72.7567C419.695 68.2767 413.22 64.7517 407.755 62.9117C421.98 64.5317 434.465 65.1067 434.87 58.9217C435.275 52.7367 421.785 46.9917 417.39 45.6067C445.04 45.8867 464.87 20.722 463.5 3.50195C462.475 -21.0332 436.1 -39.0988 384.5 -15.4988C332.9 8.10122 356.027 37.1115 374.04 48.6667C363.21 49.7617 352.04 62.7717 366.03 75.3117C347.645 68.1817 338.155 88.3717 338.16 104.027C348.065 93.6817 356.96 96.1417 377.96 101.967Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.04 75.1167C380.04 75.1167 392.865 81.3667 397.075 87.4817M397.075 87.4817C400.575 92.5667 397.035 107.257 377.96 101.967C356.96 96.1417 348.065 93.6817 338.16 104.027C338.155 88.3717 347.645 68.1817 366.03 75.3117C352.04 62.7717 363.21 49.7617 374.04 48.6667C356.027 37.1115 332.9 8.10122 384.5 -15.4988C436.1 -39.0988 462.475 -21.0332 463.5 3.50195C464.87 20.722 445.04 45.8867 417.39 45.6067C421.785 46.9917 435.275 52.7367 434.87 58.9217C434.465 65.1067 421.98 64.5317 407.755 62.9117C413.22 64.7517 419.695 68.2767 423.325 72.7567C427.525 77.9417 413.15 77.8317 399.43 75.6867C399.43 75.6867 412.71 79.5417 412.665 84.0117C412.625 87.5017 409.95 89.1667 397.075 87.4817Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.885 102.37C241.49 92.06 257.465 88.775 246.71 75.905C240.675 68.685 243.01 62.165 244.97 59.105C247.98 54.41 247.515 52.79 246.555 50.02C245.03 45.615 236.015 43.195 243.81 33.75C246.555 30.625 248.14 28 246.555 24.375C244.97 20.75 240.875 19.875 240.625 15.25C240.375 10.625 246.13 10.75 244.97 6.25C243.81 1.75 239.5 2.25 239.625 -3.375",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.69 101.67C255.55 89.5548 263.71 88.7598 265.65 83.5948C266.75 80.6698 264.58 77.6448 262.135 73.3498C260.3 70.1248 256.875 65.6398 263.525 57.1048C269.215 49.7998 254.39 44.3948 261.06 34.4648C263.525 30.125 265.225 26.875 264.375 21.25C263.525 15.625 258.875 15.125 258.375 8C257.975 2.3 261.642 -2.54167 263.525 -4.25",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.175 100.59C288.465 88.7451 277.39 87.9251 278.945 81.7351C280.055 77.3301 285.41 76.3251 282.91 71.0651C281.035 67.1201 273.835 64.5801 280.57 56.2151C288.095 46.8701 269.775 45.4701 278.03 34.4551C282.91 27.125 282.195 23.875 280.57 19.5C278.945 15.125 273.625 11.625 273.75 4.25C273.85 -1.65 276.645 -5.375 278.03 -6.5",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.49 102.981C295.865 92.1306 308.865 90.9756 299.39 80.8406C292.06 72.9956 299.135 69.6956 300.38 65.5106C302.045 59.9306 297.045 58.4406 295.315 54.2406C292.52 47.4556 305.45 42.9506 295.645 35.5156C290.125 31.375 290.435 23.75 292.875 20.25C295.315 16.75 302.28 13.875 299.39 6.75C297.078 1.05 294.083 -3.04167 292.875 -4.375",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.79 99.9206C310.37 89.9156 320.225 89.9806 313.35 80.9706C306.84 72.4356 313.805 68.8206 315.425 64.7656C317.5 59.5806 313.935 58.0256 312.055 52.8406C310.13 47.5256 322.495 42.6006 311.02 35.5156C306 32.25 309.95 25.875 313.35 20.5C316.75 15.125 309 11 309 5.375C309 0.875 310.347 -3.5 311.02 -5.125",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.545 37.8786C29.015 30.3136 23.18 28.3036 23.18 28.3036C11.036 22.0629 -7.33334 25.7033 -15 28.3036C-43.7567 21.0706 -102.993 10.9445 -109.885 28.3036V164.109C-109.885 172.789 -88.14 173.024 -85.365 160.794C-79.9 174.674 -60.995 173.109 -57.96 159.929C-40.615 171.724 -35.5 168.514 -26.045 150.389C2.74999 181.004 17.145 161.144 22.26 141.804C43.075 177.359 66.4 157.674 74.9 135.819C97.015 169.554 119.475 143.014 121.645 131.394C136.645 164.434 154.335 146.569 161.185 135.294C167.255 148.479 179.66 153.174 187.46 149.344C197.35 144.489 208.535 122.289 208.535 122.289C208.535 122.289 215.905 126.974 220.115 132.134C219.375 114.904 212.075 98.6185 203.495 97.6735C194.915 96.7285 185.475 108.504 180.325 119.439C181.83 95.9035 170.01 94.3835 163.525 98.5985C156.115 103.414 147.51 112.209 147.51 112.209C147.51 112.209 150.335 99.2735 141.27 94.5235C131.53 89.4185 121.79 93.1035 114.13 101.144C117.25 83.7435 116.685 76.1736 109.78 68.8936C102.88 61.6136 86.895 64.3586 75.075 74.8536C75.36 54.7136 71.385 39.9586 43.3 57.5486C44.905 41.9436 44.245 36.4586 28.545 37.8786Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-109.835 223.925C-101.335 205.35 -84.45 212.575 -80.245 223.505C-73.52 210.98 -65.2 210.98 -54.295 221.015C-50.48 194.955 -34.8 210.735 -26.45 221.09C-21.95 189.05 -4.03996 212.16 5.87004 221.625C5.80004 194.95 21.01 204.95 33.205 213.545C35.01 184.335 55.8301 203.21 64.1151 210.015C71.5801 187.045 82.495 186.795 95.95 197.875C103.335 176.38 112.275 181.875 126.575 192.595C136.225 156.97 157.43 188.67 157.43 188.67C157.43 188.67 163.79 169.69 171.64 168.525C184.365 166.635 192.95 175.945 201.75 184.11C201.22 184.925 180.08 179.005 180.08 179.005C180.08 179.005 184.58 199.025 179.93 204.195C175.28 209.365 167.11 208.02 154.44 204.12C152.04 217.165 151.515 226.985 125.05 217.39C127.75 234.035 130 264.7 85.54 243.705C87.115 267.095 85.165 290.64 34.485 261.475C41.085 288.165 39.36 297.835 29.535 298.96C17.245 300.365 -14.325 279.54 -14.325 279.54C-14.325 279.54 -1.02496 307.68 -9.14996 311.03C-20.245 315.605 -49.86 286.965 -49.86 286.965C-49.86 286.965 -23.62 324.75 -59.23 308.485C-49.35 323.705 -58.555 331.425 -58.555 331.425H-109.835V223.925Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.7 203.403C250.925 202.928 251.63 202.988 251.77 203.493C254.83 214.408 248.865 225.498 245.44 222.628C241.65 219.448 247.535 210.073 250.7 203.403Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.255 197.863C274.37 197.253 275.29 197.198 275.485 197.793C279.175 209.038 275.905 224.683 271.225 221.708C267.685 219.458 272.605 206.513 274.255 197.863Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.685 207.292C334.615 206.987 334.95 206.757 335.215 206.922C343.865 212.167 342.965 219.367 340.525 219.152C338.175 218.947 335.63 211.422 334.685 207.292Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.165 193.515C222.11 193.18 221.705 193.025 221.44 193.24C213.13 199.94 213.01 207.68 215.94 209.145C218.745 210.545 223.82 203.64 222.165 193.515Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.965 156.201C221.775 155.371 220.85 154.941 220.1 155.346C213.78 158.741 210.555 169.171 214.83 171.271C219.14 173.391 223.215 161.676 221.965 156.201Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.08 251.56C570.975 250.835 579.02 247.125 581 242.23",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M572.43 72.3663L528.985 85.5813C528.985 85.5813 527.735 94.8763 526.21 102.351C525.63 105.186 525.015 107.756 524.405 109.461C521.33 118.096 510.59 115.271 510.415 109.686C510.39 108.926 510.41 108.086 510.475 107.171C510.735 103.316 511.735 98.1613 513.215 92.4063C513.25 91.7013 513.29 91.0113 513.33 90.3413C514.315 74.4913 517.225 67.6663 531.515 67.2963C531.91 67.2863 532.33 67.2813 532.75 67.2813C543.565 67.2713 562.245 70.4663 572.43 72.3663Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1473_19475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 360,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid6);
export default __webpack_public_path__ + "static/media/grid6.12af74531327cd5c1d1512ce5d550ecf.svg";
export { ForwardRef as ReactComponent };